import Block from '../block'

export default class GoogleMap extends Block {
	static title = 'google-map'

	init() {
		this.mapSelector = `.${GoogleMap.title}__map`
		this.markers = []
		this.errorNode = document.querySelector('.message--error')
	}

	getDependency() {
		return `https://maps.googleapis.com/maps/api/js?key=${this.element.dataset.apiKey}&libraries=geometry`
	}

	load() {
		// element should exist to instantiate
		if (document.querySelector(this.mapSelector) === null) {
			return
		}

		// the node where te map should be put in
		const mapNode = document.querySelector(this.mapSelector)

		// instantiate the Google Maps object
		this.map = new google.maps.Map(mapNode, {
			center: {
				lat: parseFloat(this.element.getAttribute('data-latitude')),
				lng: parseFloat(this.element.getAttribute('data-longitude')),
			},
			zoom: parseInt(this.element.getAttribute('data-zoom'), 10) || 6,
		})

		if (this.element.hasAttribute('data-marker-label')) {
			const marker = this.createMarker(
				this.map,
				{
					lat: parseFloat(this.element.getAttribute('data-latitude')),
					lng: parseFloat(this.element.getAttribute('data-longitude')),
				},
				'center',
				this.element.getAttribute('data-marker-label'),
				this.element.getAttribute('data-marker-label')
			)

			this.markers.push(marker)
		}
	}

	createMarker(map, latLng, markerId, title, infoWindowContent, domNode) {
		const infoWindow = infoWindowContent
			? this.createInfoWindow(infoWindowContent)
			: null
		const marker = new google.maps.Marker({
			map,
			position: latLng,
			markerId,
			title,
			domNode,
		})

		marker.addListener('click', () => {
			if (this.map.getZoom() < 10) {
				this.map.setZoom(10)
			}
			this.map.setCenter(marker.getPosition())
			if (infoWindow) {
				infoWindow.open(this.map, marker)
			}
		})

		return marker
	}

	// create a marker popup
	createInfoWindow(infoWindowContent) {
		return new google.maps.InfoWindow({
			content: infoWindowContent,
		})
	}

	geolocationByGPS() {
		// get the GPS location
		navigator.geolocation.getCurrentPosition(
			position => {
				this.map.setCenter({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				})
				this.map.setZoom(10)
			},
			// no location received, show an error
			error => {
				if (this.errorNode) {
					this.errorNode.textContent = error.message
					this.errorNode.classList.add('message--visible')
				}
			}
		)
	}

	// get the location from the user's input
	geolocationByUserInput(userInput) {
		// request latlng from user's input
		const geocoder = new google.maps.Geocoder()
		geocoder.geocode({ address: userInput }, (results, status) => {
			if (status === google.maps.GeocoderStatus.OK && results[0]) {
				this.map.setCenter({
					lat: results[0].geometry.location.lat(),
					lng: results[0].geometry.location.lng(),
				})
			}

			this.handleGeolocation(results[0])
		})
	}

	navigateToMarker(event) {
		this.map.setCenter({
			lat: parseFloat(event.target.parentElement.getAttribute('data-latitude')),
			lng: parseFloat(
				event.target.parentElement.getAttribute('data-longitude')
			),
		})
		this.map.setZoom(10)
	}

	handleGeolocation() {}
}
